import Button from "../../../../../../publicComponent/Button";
import CountControl from "../../../../components/CountControl";
import AddCartButton from "../../../../../../reducer/moduleReducer/goodsDetail/components/AddCartButton";
import {
  GoodsDetailController,
  useGoodsDetailContext,
} from "../../../../../../reducer/moduleReducer/goodsDetail";
import { getI18n, useTranslation } from "react-i18next";
import WhiteSpec from "../../../../../../publicComponent/h5/WhiteSpec";
import GoodsDetailCommentBlock from "../../../../../../publicComponent/h5/goodsDetailCommentBlock";

function SpecItem({ spec }) {
  const { state, dispatch } = useGoodsDetailContext();

  const selectSpec = () => {
    let payload = spec;
    if (spec.specSkuId === state.spec.specSkuId) {
      payload = {};
    }

    dispatch({ type: "setSpec", payload });
  };

  return (
    <span
      onClick={selectSpec}
      className="inline-block border cursor-pointer border-[#aaa] mdmax:text-[12px]
                          rounded-[3px] py-[2px] px-[10px] ml-[5px] mdmax:mb-[5px]"
      style={{
        backgroundColor: state.spec.specName === spec.specName ? "#333" : "",
        color: state.spec.specName === spec.specName ? "#fff" : "#333",
      }}
    >
      {spec.specName}
    </span>
  );
}

function SpecList({ intro }) {
  const { t } = useTranslation();

  return (
    <div className="md:mt-[25px] md:flex-1 mdmax:pb-[70px] mdmax:px-[18px] mdmax:py-[12px]">
      <h2 className="text-[16px] font-bold mb-[5px]">{t("商品信息")}</h2>
      <div
        className="mb-[16px]"
        dangerouslySetInnerHTML={{ __html: intro }}
      ></div>
    </div>
  );
}

export default function GoodsSpec({ setSpecModalVisible }) {
  const { countHandle, gotoConfirmOrder, setSkuItem } = GoodsDetailController();
  const { state } = useGoodsDetailContext();
  const { detail, count, spec, commentTotal, commentList, skuItem } = state;
  const { t } = useTranslation();
  const lang = getI18n().language;

  if (!detail.itemName) return <></>;

  return (
    <>
      <div
        className={`bg-white md:hidden relative z-10 top-[40vh] rounded-t-[30px] pt-[22px]`}
      >
        <h2 className="text-[16px] font-bold mb-[16px] px-[18px]">
          {detail.itemName}
        </h2>

        <div className="flex mb-[22px] px-[18px]">
          <p
            onClick={() => setSpecModalVisible(true)}
            className="relative border border-[#d4d4d4] py-[5px] px-[15px] rounded-full text-[14px] min-w-[100px] mr-[12px] pr-[32px]"
          >
            {lang === "en"
              ? detail?.specList[0]?.specNameEn
              : detail?.specList[0]?.specName}
            :{spec.specName}
            <i className="absolute right-[12px] top-[7px] iconfont icon-right text-[#999] text-[12px]"></i>
          </p>

          <CountControl
            count={count}
            addCount={countHandle}
            subCount={countHandle}
          />
        </div>

        <WhiteSpec />
        <GoodsDetailCommentBlock total={commentTotal} list={commentList} />
        <WhiteSpec />
        <SpecList intro={lang === "en" ? detail.introEn : detail.intro} />
      </div>

      <div className="border-b-[1px] pb-[15px] hidden md:block">
        <h1 className="text-[22px] mb-[12px]">{detail.itemName}</h1>
        <div className="flex justify-between items-center">
          {/* <p className="text-[14px] flex-none w-[20%] text-[#999]">
            {detail.secondCategoryName}
          </p> */}
          <div className="flex-1 flex items-center">
            {/* <span className="font-bold text-[14px]">
              {detail?.specList[0]?.specName}:
            </span> */}
            <div className="inline-block flex mr-[5%]">
              {/* {detail.specListRes.map((item, i) => (
                <SpecItem key={i} spec={item} />
              ))} */}
              {detail?.specList.map((item, i) => (
                <div className="mb-[10px] mr-[10px]" key={i}>
                  <p className="text-[15px] inline-block mr-[10px]">
                    {item.specName}:
                  </p>
                  {item.specNameValueList.map((_item, j) => (
                    <a
                      key={j}
                      style={{ minWidth: 36 }}
                      onClick={() => setSkuItem(item, i, j)}
                      className={`inline-block text-center border border-[#ddd] p-[7px] px-[8px] rounded-full cursor-pointer ml-[8px] ${
                        _item === skuItem[i]?.specValue
                          ? "border-[#c7a17a] text-[#c7a17a]"
                          : ""
                      }`}
                    >
                      {_item}
                    </a>
                  ))}
                </div>
              ))}
            </div>
            <CountControl
              count={count}
              addCount={countHandle}
              subCount={countHandle}
            />
          </div>

          <h1 className="w-[20%] text-[24px] font-bold text-right">
            ${detail.priceArea}
          </h1>
        </div>
        {spec.price && <p className="text-[16px]">${spec.price}</p>}
      </div>

      <div className="text-right pt-[24px] pb-[60px] mdmax:hidden">
        <Button
          onClick={gotoConfirmOrder}
          className="rounded-none py-[15px] bg-white border border-[#ddd]
                           w-[180px] text-[15px]"
        >
          {t("现在购买")}
        </Button>
        <AddCartButton className="rounded-none mdmax:rounded-full text-white bg-[#333] ml-[1.4rem] py-[15px] border border-[#333]  mdmax:py-[8px] mdmax:flex-1 w-[180px] text-[15px] mdmax:text-[14px]" />
      </div>
      <div className="flex mdmax:hidden justify-between pb-[8%]">
        <SpecList intro={detail.intro} />
      </div>
    </>
  );
}
